import React, {useState} from "react";
import {Button, Modal, Table} from "antd";
import {defaultSorter, IconPopup} from "../utils/antdhelper/AntdHelper";
import {DeleteOutlined, DeleteTwoTone, EditTwoTone} from "@ant-design/icons";
import RoutingForm from "../components/Forms/RoutingForm";

const columnsRouting = [
    {title: "Группа пациентов",   dataIndex: "patients"},
    {title: "Этап",               dataIndex: "step"},
    {title: "Услуга/направление", dataIndex: "serv"},
    {title: "Территория",         dataIndex: "area"},
    {title: "Тип",                dataIndex: "type"},
    {title: "Цель",               dataIndex: "target"},
    {title: "Срок, дн",               dataIndex: "time"},
    {title: "Действия",           dataIndex: "idx",
    render: (text, record) => <>
        <IconPopup Icon={EditTwoTone}><RoutingForm/></IconPopup>
        <IconPopup Icon={DeleteTwoTone} twoToneColor="#eb2f96"></IconPopup>
    </>},
].map(column =>
    ({
        ...column,
        sorter: defaultSorter(column),
        key: column.dataIndex
    }))

const defaultRouting = [{
    patients: 'Диагноз:Топография ~ С50',
    step: '[1] Подозрение на ЗНО',
    serv: 'Осмотр онколога',
    area: 'Все',
    type: 'Обязательно',
    time: '3',
    target: 'РКОД: кабинет <1-24>, РКОД: кабинет <2-41>',
    idx: '1'
}]

const RoutingPage = () => {
    const [visible, setVisible] = useState(false)
    const doClose = () => setVisible(false)
    return <div>
        <Modal
            visible={visible}
            onOk={doClose}
            onCancel={doClose}
            width={1000}>
            <RoutingForm></RoutingForm>
        </Modal>
        <Table
            columns={columnsRouting}
            dataSource={defaultRouting}
            title={
                () => <>Список правил маршрутизации
                    <Button style={{float: 'right'}} type="primary" onClick={() => setVisible(true)}>Добавить</Button>
                    <Button style={{float: 'right'}}>Импорт</Button>
                    <Button style={{float: 'right'}}>Экспорт</Button>
                </>
            }/>
    </div>
}

export default RoutingPage